import type { ZodObject } from "zod";
import { useAppForm } from "../form";
import { useFormStore } from "../form.store";

type TAutoForm = {
	schema: ZodObject<any>;
	formName: string;
	onSubmit: (values: any) => void;
};

export function AutoForm({ schema, formName, onSubmit }: TAutoForm) {
	const formValues = useFormStore((state) => state.formValues);
	const formFields = useFormStore((state) => state.formFields);

	const form = useAppForm({
		defaultValues: { ...formValues },
		validators: {
			onChange: schema,
			onSubmit: schema,
		},
		onSubmit: (values) => {
			onSubmit(values);
		},
	});

	return (
		<form onSubmit={form.handleSubmit} name={formName}>
			<div className="space-y-3">
				{formFields.map((formField) => (
					<form.AppField key={formField.column_name} name={formField.column_name}>
						{(field) => (
							<field.TextField label={formField.column_name} required={!formField.is_nullable} />
						)}
					</form.AppField>
				))}
			</div>
		</form>
	);
}
